import { useEffect, useState } from 'react'
import { IoIosArrowBack } from 'react-icons/io'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import IconBtn from '../../common/IconBtn'
import { BsChevronUp } from 'react-icons/bs'
import { FiFileText, FiAward, FiLock } from 'react-icons/fi'

const VideoDetailsSidebar = ({setReviewModal}) => {

    const [activeStatus, setActiveStatus] = useState("")
    const [videoBarActive, setVideoBarActive] = useState("")
    const navigate = useNavigate()
    const location = useLocation()
    const { courseId, sectionId, subSectionId } = useParams()
    const {
        courseSectionData,
        courseEntireData,
        totalNoOfLectures,
        completedLectures,
    } = useSelector((state) => state.viewCourse)

    //Only used to label the quiz link...the server decides whether it actually opens
    const isCourseComplete =
        totalNoOfLectures > 0 && completedLectures?.length >= totalNoOfLectures

    useEffect(() => {
        ;(() => {
        if (!courseSectionData.length) return
        const currentSectionIndx = courseSectionData.findIndex(
            (data) => data._id === sectionId
        )
        const currentSubSectionIndx = courseSectionData?.[
            currentSectionIndx
        ]?.subSection.findIndex((data) => data._id === subSectionId)
        const activeSubSectionId =
            courseSectionData[currentSectionIndx]?.subSection?.[
            currentSubSectionIndx
            ]?._id
        setActiveStatus(courseSectionData?.[currentSectionIndx]?._id)
        setVideoBarActive(activeSubSectionId)
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [courseSectionData, courseEntireData, location.pathname])
    
  return (
    <>
      <div className="flex h-[calc(100vh-3.5rem)] w-[320px] max-w-[350px] flex-col border-r-[1px] border-r-richblack-700 bg-richblack-800">
        <div className="mx-5 flex flex-col items-start justify-between gap-2 gap-y-4 border-b border-richblack-600 py-5 text-lg font-bold text-richblack-25">
          <div className="flex w-full items-center justify-between ">
            <div
              onClick={() => {
                navigate(`/dashboard/enrolled-courses`)
              }}
              className="flex h-[35px] w-[35px] items-center justify-center rounded-full bg-richblack-100 p-1 text-richblack-700 hover:scale-90"
              title="back"
            >
              <IoIosArrowBack size={30} />
            </div>
            <IconBtn
              text="Add Review"
              customClasses="ml-auto"
              onClick={() => setReviewModal(true)}
            />
          </div>
          <div className="flex flex-col">
            <p>{courseEntireData?.courseName}</p>
            <p className="text-sm font-semibold text-richblack-500">
              {completedLectures?.length} / {totalNoOfLectures}
            </p>
          </div>
        </div>

        {/* Materials and quiz live alongside the lectures. The quiz page shows
        its own locked state until every lecture is done, so it is always linked */}
        <div className="flex flex-col border-b border-richblack-600 px-5 py-3">
          <button
            onClick={() => navigate(`/view-course/${courseId}/materials`)}
            className={`flex items-center gap-2 rounded px-2 py-2 text-sm ${
              location.pathname.endsWith("/materials")
                ? "bg-yellow-200 font-semibold text-richblack-800"
                : "text-richblack-25"
            }`}
          >
            <FiFileText /> Course materials
          </button>

          <button
            onClick={() => navigate(`/view-course/${courseId}/quiz`)}
            className={`mt-1 flex items-center gap-2 rounded px-2 py-2 text-sm ${
              location.pathname.endsWith("/quiz")
                ? "bg-yellow-200 font-semibold text-richblack-800"
                : "text-richblack-25"
            }`}
          >
            {isCourseComplete ? <FiAward /> : <FiLock />} Final quiz
            {!isCourseComplete && (
              <span className="ml-auto text-xs text-richblack-400">locked</span>
            )}
          </button>
        </div>

        <div className="h-[calc(100vh - 5rem)] overflow-y-auto">
          {courseSectionData.map((course, index) => (
            <div
              className="mt-2 cursor-pointer text-sm text-richblack-5"
              onClick={() => setActiveStatus(course?._id)}
              key={index}
            >
              {/* Section */}
              <div className="flex flex-row justify-between bg-richblack-600 px-5 py-4">
                <div className="w-[70%] font-semibold">
                  {course?.sectionName}
                </div>
                <div className="flex items-center gap-3">
                  {/* <span className="text-[12px] font-medium">
                    Lession {course?.subSection.length}
                  </span> */}
                  <span
                    className={`${
                      activeStatus === course?._id
                        ? "rotate-0"
                        : "rotate-180"
                    } transition-all duration-500`}
                  >
                    <BsChevronUp />
                  </span>
                </div>
              </div>

              {/* Sub Sections */}
              {activeStatus === course?._id && (
                <div className="transition-[height] duration-500 ease-in-out">
                  {course.subSection.map((topic, i) => (
                    <div
                      className={`flex gap-3  px-5 py-2 ${
                        videoBarActive === topic._id
                          ? "bg-yellow-200 font-semibold text-richblack-800"
                          : "hover:bg-richblack-900"
                      } `}
                      key={i}
                      onClick={() => {
                        navigate(
                          `/view-course/${courseEntireData?._id}/section/${course?._id}/sub-section/${topic?._id}`
                        )
                        setVideoBarActive(topic._id)
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={completedLectures.includes(topic?._id)}
                        onChange={() => {}}
                      />
                      {topic.title}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default VideoDetailsSidebar
